import { handleActions } from "redux-actions";
import * as addCustomerActions from "../actions/customers";

const initState = {
  customerTypes: null,
  customersStat: null,
  allCustomers: [],
  filterCustomers: null,
  filterCustomersStat: null,
  customersLoading: false,
  isEdit: false,
  isAdd: false,
  errorMessage: null
};

export const customers = handleActions(
  {
    [addCustomerActions.searchCustomers]: (state, _action) => {
      return { ...state, customersLoading: true };
    },
    [addCustomerActions.searchCustomersSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        allCustomers: payload.data,
        customersLoading: false
      };
    },
    [addCustomerActions.searchCustomersError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload.data.message,
        customersLoading: false
      };
    },
    [addCustomerActions.getFilterCustomers]: (state, _action) => {
      return { ...state, customersLoading: true };
    },
    [addCustomerActions.getFilterCustomersSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        filterCustomers: payload.customers,
        filterCustomersStat: payload.customersStat,
        customersLoading: false
      };
    },
    [addCustomerActions.getFilterCustomersError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload.data.message,
        customersLoading: false
      };
    },
    [addCustomerActions.getAllCustomers]: (state, _action) => {
      return { ...state, customersLoading: true };
    },
    [addCustomerActions.getAllCustomersSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        allCustomers: payload.customers,
        customersStat: payload.customersStat,
        customerTypes: payload.customerTypes,
        customersLoading: false
      };
    },
    [addCustomerActions.getAllCustomersError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload.data.message,
        requestsLoading: false
      };
    },
    [addCustomerActions.addCustomer]: (state, action) => {
      return {
        ...state,
        isAdd: false
      };
    },
    [addCustomerActions.addCustomerSuccess]: (state, action) => {
      return {
        ...state,
        isAdd: true
      };
    },
    [addCustomerActions.addCustomerError]: (state, action) => {
      return {
        ...state,
        isAdd: false,
        errorMessage: action.payload
      };
    },
    [addCustomerActions.clearAddCustomerErrors]: state => {
      return {
        ...state,
        errorMessage: null
      };
    }
  },
  initState
);
